"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Может быть с переходом на оплату и без перехода.
Это понятно по полю `budgetDiffInCents`, если оно > 0, то нужна оплата.
 */
const auctionModalEditCampaignButtonClick = ({ action, vacancyId, campaignId, bidInCents, budgetInCents, budgetDiffInCents, campaignStatus, maxBidAmongSimilarVacancies, useAvailableMoney, availableMoneyInCents, ...analyticsParams }) => analytics_js_1.default.sendHHEventButtonClick("auction_modal_edit_campaign", { action, vacancyId, campaignId, bidInCents, budgetInCents, budgetDiffInCents, campaignStatus, maxBidAmongSimilarVacancies, useAvailableMoney, availableMoneyInCents, ...analyticsParams });
exports.default = auctionModalEditCampaignButtonClick;
